import { resolve } from 'styled-jsx/css';
import { colors } from 'components/styles/variables';

/*

To use these styles you must:

1. add className={`autolist-button ${AutolistButtonStyles.className}`} to the
   element you want to styles.
2. Add {AutolistButtonStyles.styles} nested within the root container element.

<div>
  <a
    href="https://www.research.net/r/autolist-dealer-review"
    target="_blank"
    className={`autolist-button ${AutolistButtonStyles.className}`}
  >
    {t('dealerPages.writeAReview')}
  </a>
  {AutolistButtonStyles.styles}
</div>

*/

/* istanbul ignore next */
export default resolve`
  .autolist-button {
    background-color: white;
    color: ${colors.ALR1};
    border: 2px solid ${colors.G1};
    border-radius: 8px;
    font-size: 16px;
    font-weight: 900;
    padding: 13px;
    width: 100%;
    text-align: center;
  }

  .autolist-button:hover {
    background-color: ${colors.ALR1};
    color: white;
    border: solid 2px ${colors.ALR1};
  }
`;
